import React from "react";
import { ClipboardCheck } from "lucide-react";

const actionStyles = {
  APPLICATION_APPROVED: { bg: "bg-green-100 text-green-700", label: "Approved" },
  APPLICATION_REJECTED: { bg: "bg-red-100 text-red-700",     label: "Rejected" },
};

const AuditTable = ({ auditLogs = [] }) => {
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
          <ClipboardCheck size={16} className="text-primary" />
        </div>
        <h3 className="text-base font-semibold text-gray-800">Audit Trail</h3>
        {auditLogs.length > 0 && (
          <span className="ml-auto text-xs text-gray-400">{auditLogs.length} entries</span>
        )}
      </div>

      {auditLogs.length === 0 ? (
        <div className="text-center py-10 text-gray-400 text-sm">
          No audit logs available
        </div>
      ) : (
        <div className="overflow-auto max-h-[400px] rounded-xl border border-gray-100">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-white border-b border-gray-100">
              <tr>
                {["Action", "Admin", "Application", "Time"].map((h) => (
                  <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-400 uppercase tracking-wide">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {auditLogs.map((log) => {
                const style = actionStyles[log.action] || { bg: "bg-gray-100 text-gray-600", label: null };
                const initials = log.performedBy?.fullName?.charAt(0)?.toUpperCase() || "A";
                return (
                  <tr key={log._id} className="hover:bg-gray-50 transition-colors duration-100">

                    {/* Action badge */}
                    <td className="px-4 py-3">
                      <span className={`inline-flex px-2.5 py-1 text-xs rounded-full font-semibold ${style.bg}`}>
                        {style.label || log.action?.replace("APPLICATION_", "") || "UNKNOWN"}
                      </span>
                    </td>

                    {/* Admin */}
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center text-xs font-bold flex-shrink-0">
                          {initials}
                        </div>
                        <span className="text-gray-700 text-sm">{log.performedBy?.fullName || "Admin"}</span>
                      </div>
                    </td>

                    {/* Application */}
                    <td className="px-4 py-3 text-gray-500 text-xs">
                      {log.applicationId?.studentId?.fullName ||
                        log.applicationId?._id || "N/A"}
                    </td>

                    {/* Timestamp */}
                    <td className="px-4 py-3 text-gray-400 text-xs whitespace-nowrap">
                      {log.timestamp
                        ? new Date(log.timestamp).toLocaleString()
                        : log.createdAt
                        ? new Date(log.createdAt).toLocaleString()
                        : "N/A"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AuditTable;
